/**
 * @file        src/lib/tariffs/recyclingReference.ts
 * @description Public entry for the ПП 1291 (§I) recycling-tariff reference. Thin re-export over
 *              reference/{types,validation,lookup}.ts (split for the 200-line limit). Importing this
 *              module validates the JSON on load (validation runs as an import side-effect).
 *              Revision-keyed: findCoefficientKw takes a revision; resolveRevision picks it by date.
 *              LIVE since CALC-NORM-01 (2026-09-30): the recycling fee of every calculation is read
 *              here through src/lib/tariffs/recyclingFee.ts.
 * @rule        Coefficients live in the JSON, never in TS. Editing numbers here breaks the
 *              provenance chain recorded in the JSON.
 * @rule        Indexation is NEVER computed. Every revision is a column of the decree text, stored
 *              explicitly — x1.2 is wrong in 1 of 160 cells (96,11 -> published 115,34, not 115,332).
 * @universal   knowledge/universals/tools.md#recycling-tariff-reference-pp-1291-section-i
 */

export type {
  AgeColumn,
  RecyclingBracket,
  IceVolumeBlockKey,
  ParagraphKey,
  RevisionKey,
  RevisionMeta,
  RecyclingProvenance,
} from './reference/types';

export {
  findCoefficientKw,
  resolveRevision,
  volumeBlockForCc,
  REVISION_LABELS,
  provenance,
  REFERENCE_REVISION,
  RECYCLING_BASE_RUB,
} from './reference/lookup';

export {
  REVISION_KEYS,
  VOLUME_BLOCK_KEYS,
  KW_ICE_PREFERENTIAL_CEIL,
  KW_EV_PREFERENTIAL_CEIL,
} from './reference/validation';
